<mat-card>
  <mat-card-content>
    <button [routerLink]="['counties']" mat-raised-button>Counties</button>
    <button [routerLink]="['cities']" mat-raised-button>Cities</button>
    <button [routerLink]="['states']" mat-raised-button>States</button>
    <router-outlet></router-outlet>
  </mat-card-content>
</mat-card>